import React, {useState} from 'react';
import {ErrorMessage, Field, Form, Formik} from 'formik';
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import "./_roleCreate.scss";
import {ADMIN_ROLE_DISPLAY, ROLES} from 'common/constants';
import {api} from 'api/calls';
import ComLoader from 'components/comLoader/ComLoader';
import {routes} from 'common';
import {getAvailablePermissions, getPermissionDisplayName, subRoleValidationSchema} from 'pages/roles/constants';

function RoleCreate() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const initialValues = {
    name: '',
    description: '',
    role: ROLES.GROUND_ADMIN,
    permissions: [],
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await api.createSubRole(values);
      toast.success('Role created successfully!');
      navigate(routes.ROLES);
    } catch (error) {
      console.error('Error creating role:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(routes.ROLES);
  };

  return (
    <div className="role-create-page detail-page">
      <div className="header">
        <h1>Create New Sub Role</h1>
        <p className="subtitle">Add a new sub role with custom permissions</p>
      </div>

      <Formik
        initialValues={initialValues}
        validationSchema={subRoleValidationSchema}
        onSubmit={handleSubmit}
      >
        {({values, errors, touched, setFieldValue}) => {
          const availablePermissions = getAvailablePermissions(values.role);

          return (
            <Form className="custom-form">
              <div className="form-group">
                <label htmlFor="name">
                  Name <span className="required">*</span>
                </label>
                <Field
                  type="text"
                  id="name"
                  name="name"
                  className={`form-control ${touched.name && errors.name ? 'is-invalid' : ''}`}
                  placeholder="Enter name"
                />
                <ErrorMessage name="name" component="div" className="error-message"/>
              </div>

              <div className="form-group">
                <label htmlFor="description">
                  Description
                </label>
                <Field
                  as="textarea"
                  id="description"
                  name="description"
                  className={`form-control ${touched.description && errors.description ? 'is-invalid' : ''}`}
                  placeholder="Enter description"
                  rows="4"
                />
                <ErrorMessage name="description" component="div" className="error-message"/>
              </div>

              <div className="form-group">
                <label htmlFor="role">
                  Role <span className="required">*</span>
                </label>
                <Field
                  as="select"
                  id="role"
                  name="role"
                  className={`form-control ${touched.role && errors.role ? 'is-invalid' : ''}`}
                  onChange={(e) => {
                    setFieldValue('role', e.target.value);
                    setFieldValue('permissions', []); // Reset permissions when role changes
                  }}
                >
                  {Object.entries(ADMIN_ROLE_DISPLAY).map(([key, display]) => (
                    <option key={key} value={key}>
                      {display}
                    </option>
                  ))}
                </Field>
                <ErrorMessage name="role" component="div" className="error-message"/>
              </div>

              <div className="form-group">
                <label>
                  Permissions <span className="required">*</span>
                </label>
                <div className="checkbox-container">
                  {availablePermissions.map((permission) => (
                    <div key={permission} className="checkbox-item-wrapper">
                      <label className="checkbox-item">
                        <Field
                          type="checkbox"
                          name="permissions"
                          value={permission}
                          className="checkbox-input"
                        />
                        <span className="checkbox-label">
                          {getPermissionDisplayName(permission)}
                        </span>
                      </label>
                    </div>
                  ))}
                </div>
                <ErrorMessage name="permissions" component="div" className="error-message"/>
              </div>

              <div className="actions-section">
                <button
                  className="submit-btn primary"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? <ComLoader/> : "Create"}
                </button>

                <button
                  className="submit-btn secondary"
                  type="button"
                  onClick={handleCancel}
                  disabled={loading}
                >
                  Cancel
                </button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

export default RoleCreate;